import CommunityPageHeader from "./CommunityPageHeader";
import NewsListItem from "./NewsListItem";

import '../css/news_list.css'
import { Fragment } from "react";

function NewsListPage({activeCommunitySubcategory, setActiveCommunitySubcategory, news, countryName, phoneNumber}){
    return <div className="news-page">
        <CommunityPageHeader activeCommunitySubcategory={activeCommunitySubcategory} setActiveCommunitySubcategory={setActiveCommunitySubcategory} countryName={countryName} phoneNumber={phoneNumber}/>
        <div className="news-container">
            {news.map((single_news, index) => (
                <Fragment>
                    <NewsListItem news={single_news} phoneNumber={phoneNumber}/>
                    {index !== news.length - 1 &&  <div className="news-separator"/>}
                </Fragment>
            ))}
            <div className='news-breakline'/>
        </div>
    </div>
};

export default NewsListPage;